var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#1FDFEB"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_radial)",
    style: {
      mixBlendMode: "darken"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1901 67.486H25.1901C23.7091 67.486 22.5065 66.2835 22.5065 64.8025C22.5065 63.3215 23.7091 62.1189 25.1901 62.1189H75.1901C76.6711 62.1189 77.8736 63.3215 77.8736 64.8025C77.8736 66.2835 76.6711 67.486 75.1901 67.486Z",
    fill: "#030822"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2602 41.1697C79.2602 44.3596 76.6779 46.9545 73.4754 46.9545C70.2855 46.9545 67.6906 44.3596 67.6906 41.1697C67.6906 37.9799 70.2855 35.3849 73.4754 35.3849C76.6653 35.3849 79.2602 37.9799 79.2602 41.1697Z",
    fill: "#030822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1077 41.1694C33.1077 44.3593 30.5128 46.9542 27.3229 46.9542C24.133 46.9542 21.5381 44.3593 21.5381 41.1694C21.5381 37.9796 24.133 35.3846 27.3229 35.3846C30.5254 35.3846 33.1077 37.9796 33.1077 41.1694Z",
    fill: "#030822"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.25 40.7692) rotate(96.0235) scale(59.5596 59.5396)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.854067,
    stopColor: "#FFBB54",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854167,
    stopColor: "#FFDA54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854267,
    stopColor: "#FFBB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.854367,
    stopColor: "#12BDC8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkay);
export default __webpack_public_path__ + "static/media/Okay.b91fb6b053180f7386286eaa4b69e182.svg";
export { ForwardRef as ReactComponent };